// extracted by mini-css-extract-plugin
module.exports = {"langPopup":"styles_langPopup__DnQp9","langPopupLangsList":"styles_langPopupLangsList__YUKpl"};